import React, {useState} from 'react';
import moment from 'moment';
import Button from '../../elements/Button';
import DropdownButton from '../../elements/DropdownButton';
import Input from '../../elements/Input';
import Text from '../../elements/Text';
import DropdownOptionsDrawer from '../DropdownOptionsDrawer';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {
  BUTTON_TYPES,
  DIABETES_TYPES,
  GENDER_OPTIONS,
} from '../../../utils/Constants';
import {Platform} from 'react-native';
import UI from './ui';
import {tID} from '../../../utils/TestIdHelper';

const PersonalDetails = ({
  children,
  firstName,
  lastName,
  gender,
  dateOfBirth,
  diabetesTypes,
  otherDiabetesType,
  timeFormat,
  setFirstName,
  setLastName,
  setGender,
  setDateOfBirth,
  onPressChangePassword,
  setOtherDiabetesType,
  setDiabetesTypes,
  setTimeFormat,
  firstNameError,
  lastNameError,
  otherTypeError,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const genderOptions = Object.keys(GENDER_OPTIONS);

  // const [selectedIndex, setSelectedIndex] = useState(gender);
  const [visible, setvisible] = useState(false);
  const [visibleDiabetesTypes, setVisibleDiabetesTypes] = useState(false);
  const [visibleDatePicker, setVisibleDatePicker] = useState(false);
  const [visibleTimeFormat, setVisibleTimeFormat] = useState(false);

  const timeFormatOptions = ['12-hour', '24-hour'];
  const getTimeFormatDisplay = () => {
    return timeFormat === '12' ? '12-hour' : '24-hour';
  };

  const uiProps = {
    dateOfBirth,
    setDateOfBirth,
    visibleDatePicker,
    setVisibleDatePicker,
  };

  return (
    <UI {...uiProps}>
      <Text
        testID={tID('PersonalDetails-Text-Title')}
        variation="Headline4SemiBold22"
        color={colors.textHeading}>
        Personal Details
      </Text>
      <Input
        testID={tID('PersonalDetails-Input-FirstName')}
        hasError={firstNameError}
        errorText="Name can only contain letters."
        placeholder={'Type here...'}
        inputTitle={'First Name'}
        topMargin={24}
        value={firstName}
        onChangeText={setFirstName}
      />

      <Input
        testID={tID('PersonalDetails-Input-LastName')}
        hasError={lastNameError}
        errorText="Name can only contain letters."
        placeholder={'Type here...'}
        inputTitle={'Last Name'}
        topMargin={24}
        value={lastName}
        onChangeText={setLastName}
      />

      <DropdownButton
        placeholder={'Select...'}
        inputTitle={'Identify As'}
        topMargin={24}
        value={gender}
        onPress={() => setvisible(!visible)}
      />

      {Platform.OS === 'web' ? (
        <>
          <Text
            testID={tID('PersonalDetails-Text-DateOfBirth')}
            variation="Body1SemiBold"
            color={colors.textMuted}
            style={styles.inputTitleStyle}>
            Date of Birth
          </Text>
          {children}
        </>
      ) : (
        <DropdownButton
          placeholder={'Select...'}
          inputTitle={'Date Of Birth'}
          topMargin={24}
          value={dateOfBirth ? moment(dateOfBirth).format('MM/DD/YYYY') : ''}
          onPress={() => setVisibleDatePicker(!visible)}
        />
      )}

      <DropdownButton
        placeholder={'Select...'}
        inputTitle={'Diabetes Type'}
        topMargin={24}
        value={diabetesTypes.join(', ')}
        onPress={() => setVisibleDiabetesTypes(true)}
      />

      {diabetesTypes.includes('Other') && (
        <Input
          testID={tID('PersonalDetails-Input-OtherDiatbetesType')}
          // hasError={hasError}
          placeholder={'Type here...'}
          topMargin={24}
          value={otherDiabetesType}
          onChangeText={setOtherDiabetesType}
        />
      )}

      <DropdownButton
        placeholder={'Select...'}
        inputTitle={'Time Format'}
        topMargin={24}
        value={getTimeFormatDisplay()}
        onPress={() => setVisibleTimeFormat(true)}
      />

      <Button
        testID={tID('PersonalDetails-Button-ChangePassword')}
        topMargin={24}
        disabled={false}
        style={styles.button}
        onPress={onPressChangePassword}
        title={'Change Password'}
      />

      <DropdownOptionsDrawer
        options={genderOptions}
        visible={visible}
        title="Identify As"
        selectedOptions={[gender]}
        buttons={[
          {
            title: 'Cancel',
            buttonType: BUTTON_TYPES.Bordered,
            onPress: () => {
              setvisible(!visible);
            },
          },
          {
            title: 'Confirm',
            buttonType: BUTTON_TYPES.Filled,
            onPress: selected => {
              setvisible(!visible);
              if (selected.length > 0) {
                setGender(selected[0]);
              }
            },
          },
        ]}
        containerStyle={Platform.OS === 'web' && styles.dropdownModal}
      />

      <DropdownOptionsDrawer
        multiSelect
        options={Object.keys(DIABETES_TYPES)}
        visible={visibleDiabetesTypes}
        title="Diabetes Type"
        selectedOptions={diabetesTypes}
        buttons={[
          {
            title: 'Cancel',
            buttonType: BUTTON_TYPES.Bordered,
            onPress: () => {
              setVisibleDiabetesTypes(false);
            },
          },
          {
            title: 'Confirm',
            buttonType: BUTTON_TYPES.Filled,
            onPress: selected => {
              setVisibleDiabetesTypes(false);
              setDiabetesTypes(selected);
            },
          },
        ]}
        containerStyle={Platform.OS === 'web' && styles.dropdownModal}
      />

      <DropdownOptionsDrawer
        options={timeFormatOptions}
        visible={visibleTimeFormat}
        title="Time Format"
        selectedOptions={[getTimeFormatDisplay()]}
        buttons={[
          {
            title: 'Cancel',
            buttonType: BUTTON_TYPES.Bordered,
            onPress: () => {
              setVisibleTimeFormat(false);
            },
          },
          {
            title: 'Confirm',
            buttonType: BUTTON_TYPES.Filled,
            onPress: selected => {
              setVisibleTimeFormat(false);
              if (selected.length > 0) {
                // Convert "12-hour" or "24-hour" to "12" or "24"
                const format = selected[0].startsWith('12') ? '12' : '24';
                setTimeFormat(format);
              }
            },
          },
        ]}
        containerStyle={Platform.OS === 'web' && styles.dropdownModal}
      />
    </UI>
  );
};

export default PersonalDetails;
